// Import dependencies
import React from 'react';
import { useNavigate } from 'react-router-dom';


// Import CSS & assets
import './CTA.css';


const CTA_Promoteur = ({ origin, setToggleFullSizeGeneral, setContactGlowing }) => {

    // Set global functions
    const navigate = useNavigate();

    const handleSignUp = () => {
        setToggleFullSizeGeneral(true);
        setTimeout(() => {
            navigate('/auth?type=signup' + (origin !== null ? '&origin=' + origin : ''));
        }, 1200);
    }

    const handleContact = () => {
        document.getElementById('contact').scrollIntoView();
        document.getElementById('message').value = "Bonjour,\nJe souhaiterais planifier une démonstration de votre solution.";
        setContactGlowing(200);
    }

    //Email
    function prepareEmail() {
        var subject = "Demande d'information";
        var body = "Bonjour,\r\n\r\nJe souhaite avoir plus d'information sur Proplab.\r\n\r\nMerci de me recontacter à ce sujet.";
        var uri = "mailto:hello@proplab.fr?subject=";
        uri += encodeURIComponent(subject);
        uri += "&body=";
        uri += encodeURIComponent(body);
        window.open(uri);
    }

    return (
        <div className="landing__cta section__padding">
            <div className="landing__cta_container">
                <div className="landing__cta_content">
                    <p>Essayez notre solution</p>
                    {/* <p onClick={() => { document.getElementById('contact').scrollIntoView() }}>Demander une démonstration</p> */}
                    <h3>Découvrez comment accélérer vos études foncières sans aucune installation, contactez notre équipe.</h3>
                </div>
                <div className="landing__cta_btn">
                    {/* <button type="button" onClick={handleSignUp}>S'inscrire gratuitement</button>
                    <button type="button" onClick={handleContact}>Demander une démonstration</button> */}
                    <button type="button" onClick={() => { prepareEmail() }}>hello@proplab.fr</button>
                </div>
            </div>
        </div>
    );
};

export default CTA_Promoteur;